import { InvoiceHeader } from "@/model/entities/invoice-header";
import {
  DialogBaseComponent,
  DialogParams,
} from "@/shared/dialog-base.component";
import { DomainService } from "@/shared/domain.service";
import { UtilFns } from "@/shared/util-fns";
import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { environment } from "environments/environment";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";

export interface PackingSlipPrintDialogParams extends DialogParams {
  invoice: InvoiceHeader;
  /** if we are not already on the preview page */
  canPreview: boolean;
}

@Component({
  selector: "uni-packing-slip-print-dialog",
  templateUrl: "./packing-slip-print-dialog.component.html",
  standalone: false,
})
export class PackingSlipPrintDialogComponent extends DialogBaseComponent<PackingSlipPrintDialogParams> {
  invoice?: InvoiceHeader;
  canPreview = false;
  pdfurl = "";

  constructor(
    public config: DynamicDialogConfig<PackingSlipPrintDialogParams>,
    public dialogRef: DynamicDialogRef,
    public domainService: DomainService,
    private router: Router
  ) {
    super(config, dialogRef, domainService);
    Object.assign(this.config, {
      width: "800px",
      height: "340px",
    });
    this.prepare();
  }

  async prepare() {
    this.invoice = this.params.invoice;
    this.canPreview = this.params.canPreview;
    this.config.header = "Print Packing Slip";

    this.pdfurl =
      environment.apiRoot +
      "api/pdf/pdffromurl/packingSlip" +
      this.invoice.id +
      "?url=" +
      UtilFns.getBaseUrl() +
      "printable-packing-slip/" +
      this.invoice.id +
      "&headerLeft=Packing Slip " +
      this.invoice.id;
    this.isPageReady = true;
  }

  printDocument() {
    const pwin = window.open(this.pdfurl, "_blank");
  }

  showPreview() {
    this.router.navigateByUrl("/printable-packing-slip/" + this.invoice.id);
    this.close();
  }

  close() {
    this.dialogRef.close(null);
  }
}
